<template>
  <portal :to="target">
    <transition name="modal-overlay-fade">
      <modal-wrapper v-if="popup_open" :class="modal_name + '-modal'" :closeable="closeable" :type="type"
                     @close="$emit('close')">
        <template v-slot:modal-content>
          <template v-if="title">
            <div :class="[{'tw-justify-center' : align_header_center}, 'tw-flex tw-items-center tw-mb-5']">
              <i v-if="icon" :class="'fa-' + icon" class="far tw-mr-2 tw-text-xl"></i>
              <h4 class="tw-text-lg tw-font-semibold" v-text="title"></h4>
            </div>
          </template>
          <slot name="modal-content"></slot>
        </template>
        <template v-slot:modal-bottom>
          <slot name="modal-bottom"></slot>
        </template>
      </modal-wrapper>
    </transition>
  </portal>
</template>

<script>
import {mapState} from 'vuex';

import ModalWrapper from './ModalWrapper.vue';

export default {
  name: 'Modal',

  components: {
    'modal-wrapper': ModalWrapper,
  },

  props: {
    modal_name: {
      required: true,
      type: String,
    },
    type: {
      type: String,
      default: 'dialog',
    },
    title: {
      default: false,
    },
    icon: {
      default: false,
    },
    closeable: {
      default: true,
    },
    align_header_center: {
      default: false,
    },
    target: {
      default: 'modal'
    }
  },

  computed: {
    ...mapState('modal',
      ['popup_open', 'popup_name']),
  },
};
</script>
